import { AuthenticationDetails, CognitoUser, CognitoUserPool } from "amazon-cognito-identity-js";

const poolId = import.meta.env.VITE_COGNITO_USER_POOL_ID || "";
const clientId = import.meta.env.VITE_COGNITO_CLIENT_ID || "";

function pool() {
  if (!poolId || !clientId) throw new Error("Cognito is not configured.");
  return new CognitoUserPool({ UserPoolId: poolId, ClientId: clientId });
}

export function signIn(email: string, password: string): Promise<string> {
  return new Promise((resolve, reject) => {
    const user = new CognitoUser({ Username: email, Pool: pool() });
    user.authenticateUser(new AuthenticationDetails({ Username: email, Password: password }), {
      onSuccess: (session) => resolve(session.getIdToken().getJwtToken()),
      onFailure: reject,
      newPasswordRequired: () => reject(new Error("Set a permanent password before signing in."))
    });
  });
}

export function currentToken(): Promise<string | null> {
  return new Promise((resolve) => {
    let user: CognitoUser | null;
    try { user = pool().getCurrentUser(); } catch { resolve(null); return; }
    if (!user) { resolve(null); return; }
    user.getSession((error: Error | null, session: { isValid(): boolean; getIdToken(): { getJwtToken(): string } }) => {
      resolve(!error && session?.isValid() ? session.getIdToken().getJwtToken() : null);
    });
  });
}

export function signOut() { pool().getCurrentUser()?.signOut(); }
